export default {
    compassWidget: "esri/widgets/Compass",
    homeWidget: "esri/widgets/Home",
    legendWidget: "esri/widgets/Legend",
    locateWidget: "esri/widgets/Locate",
    searchWidget: "esri/widgets/Search",
    basemapGalleryWidget: "esri/widgets/BasemapGallery", 
    expandWidget: "esri/widgets/Expand"
};
